export default "__VITE_ASSET__DmXRCtNe__"